import { ref, watch } from 'vue';
import { useSertStore } from '@/stores/sertStore';

export const useValidation = (modelValue, options = {}) => {

    
    const storeSert = useSertStore();   

    const isValid = ref(false);
    const isTouched = ref(false);
    const textError = ref(null);
    const formPassword = ref(null);
    
    const validation = (field, rawValue = modelValue.value) => {
        isTouched.value = true;

        if(field === 'firstName'){
            isValid.value = modelValue.value?.trim().length >= 2;
            textError.value = isValid.value ? '' : 'Введите Имя';
            storeSert.updateCheckedItem('firstName', 'disabledBtn', isValid.value);
        }

        // if(field === 'lastName'){
        //     isValid.value = modelValue.value?.trim().length >= 2;
        //     textError.value = isValid.value ? '' : 'Введите Фамилию';
        //     storeSert.updateCheckedItem('lastName', 'disabledBtn', isValid.value);
            
        // }

        if(field == 'phone'){  
            const cleanNumber = (rawValue ?? '').replace(/\D/g, '').slice(0, 11);
			isValid.value = cleanNumber.length === 11
			textError.value = isValid.value ? '' : 'Введите номер телефона'
			storeSert.updateCheckedItem('phone', 'disabledBtn', isValid.value)
		}

        if (field === 'email') {
            const emailPattern = /^(?![._%+\-])([A-Za-z0-9._%+\-]{1,})@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
            isValid.value = emailPattern.test(modelValue.value) && modelValue.value.length >= 5;
            textError.value = isValid.value ? '' : 'Укажите корректный email';
            storeSert.updateCheckedItem('email', 'disabledBtn', isValid.value);
        }

        if(field === 'rules'){
            isValid.value = modelValue.value;
            storeSert.updateCheckedItem('rules', 'disabledBtn', isValid.value);
        }

        if(field === 'agreement'){
            isValid.value = modelValue.value;
            storeSert.updateCheckedItem('agreement', 'disabledBtn', isValid.value);
        }

        if(field === 'advertising'){
            isValid.value = modelValue.value;
            storeSert.updateCheckedItem('advertising', 'disabledBtn', isValid.value);
        }

        if(field === 'imagePath'){
            isValid.value = modelValue.value;
            storeSert.updateCheckedItem('imagePath', 'disabledBtn', isValid.value);
        }

        if(field === 'physicalCertificate'){
            isValid.value = modelValue.value;
            storeSert.updateCheckedItem('physicalCertificate', 'disabledBtn', isValid.value);
        }

        if(field === 'select'){
            isValid.value = modelValue.value ;
            storeSert.updateCheckedItem('select', 'disabledBtn', isValid.value);
        }

        if(field == 'password'){
            const raw = modelValue.value ?? ''; 
            isValid.value = raw.trim().length >= 6;
            formPassword.value = modelValue.value;
            textError.value = isValid.value ? '' : 'Введите пароль не менее 6 символов';
            storeSert.updateCheckedItem('password', 'disabledBtn', isValid.value);
        }
        if(field == 'passwordRepeat'){
            const raw = modelValue.value ?? ''; 
            const originalPassword = options?.originalPassword?.value || '';
            isValid.value = raw.trim().length >= 6 && raw === originalPassword;
            textError.value = isValid.value ? '' : 'Повторите пароль';
            storeSert.updateCheckedItem('passwordRepeat', 'disabledBtn', isValid.value);
        }
        if(field === 'confirmationCode'){
			const raw = modelValue.value ?? ''; 
            isValid.value = raw.trim().length >= 4;
			// textError.value = isValid.value ? '' : 'Введите код из смс';
            storeSert.updateCheckedItem('confirmationCode', 'disabledBtn', isValid.value);            
        }
        if(field === 'message'){
            isValid.value = modelValue.value?.trim().length >= 5;
            storeSert.updateCheckedItem('message', 'disabledBtn', isValid.value);
        }
    }
   
    return {
        validation,

        isTouched,
        isValid,
        textError,
    }
}